import FieldModel from '@/lib/components/models/field';
import UiDuniaBaseField from '@/forms/components/ui-dunia/base-field';
import errorHelpers from '@/forms/helpers/error';
import flowManager from '@/lib/services/flow-manager';

const { getFirstErrorMessage } = errorHelpers;

const dataIdName = 'data-test-id';

const parseWrapperValidations = (validations, data) => {
  const parsed = validations.map((val) => {
    if (typeof val === 'function') {
      return val(data);
    }
    return val;
  });

  return parsed;
};

const changeValueAndNextStep = changeValueFn => async (value) => {
  await changeValueFn(value);
  await flowManager.goToNextStep();
};

const addDefaultValidations = (validations, context) => {
  const {
    data: { defaultValidations },
    componentOptions: { Ctor: { extendOptions: { defaultValidations: wrapperValidations } } },
  } = context.children[0];

  let functionalValidations;

  if (context.children[0].fnOptions) {
    functionalValidations = context.children[0].fnOptions.defaultValidations;
  }

  let finalValidations = [];

  if (defaultValidations) {
    finalValidations = [...finalValidations, ...defaultValidations];
  }

  if (wrapperValidations) {
    const proccesedWrapperValidations = parseWrapperValidations(
      wrapperValidations,
      context.data.attrs,
    );
    finalValidations = [...finalValidations, ...proccesedWrapperValidations];
  }

  if (functionalValidations) {
    finalValidations = [...finalValidations, ...functionalValidations];
  }

  if (validations) {
    finalValidations = [...finalValidations, ...validations];
  }

  return finalValidations;
};

const addPropsVnodeWrapper = (vnode, {
  name,
  label,
  nextStepOnChange,
  onChangeHandler,
  afterChangeHandler,
}) => ({
  value,
  onChange,
  canEditValue,
  fieldId,
  validationState,
  errorMessages,
  onInstantChange,
  dataTestId,
}) => {
  const vnodeProps = vnode.componentOptions.propsData;
  let onChangeFn = onChange;

  vnodeProps.onInstantChange = onInstantChange;
  vnodeProps.value = value;
  vnodeProps.isDisabled = !canEditValue;
  vnodeProps.validationState = validationState;
  vnodeProps.fieldId = fieldId;
  vnodeProps.errorMessage = getFirstErrorMessage(errorMessages);

  if (nextStepOnChange) {
    onChangeFn = changeValueAndNextStep(onChange);
  }

  vnodeProps.onChange = async (...args) => {
    await onChangeHandler(...args);
    const output = await onChangeFn(...args);
    await afterChangeHandler();
    return output;
  };


  if (label) {
    vnodeProps.label = label;
  }

  vnodeProps.name = name;

  if (!vnode.data.attrs) {
    vnode.data.attrs = {};
  }
  vnode.data.attrs[dataIdName] = dataTestId;

  return vnode;
};

export default {
  name: 'UiWrapper',
  functional: true,
  inheritAttrs: false,

  props: {
    nextStepOnChange: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    afterChange: {
      type: Function,
      default: () => {},
    },
  },

  render(createElement, context) {
    const { data: { attrs }, props } = context;
    const {
      nextStepOnChange,
      onChange,
      afterChange,
    } = props;

    const {
      name,
      validations,
      label,
    } = attrs;
    const main = context.slots().default[0];

    attrs.ui = UiDuniaBaseField;
    attrs.validations = addDefaultValidations(validations, context);

    const renderUiComponent = addPropsVnodeWrapper(main, {
      name,
      label,
      nextStepOnChange,
      onChangeHandler: onChange,
      afterChangeHandler: afterChange,
    });

    const fieldModel = createElement(
      FieldModel,
      {
        props: attrs,
        scopedSlots: {
          default: renderUiComponent,
        },
      },
    );

    return fieldModel;
  },
};
